export const getClientPlatform = (): string => {
  const platform =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    navigator?.platform || navigator?.userAgent;

  return platform.toLocaleLowerCase().includes("win") ? "windows" : "posix";
};
